import { render, staticRenderFns } from "./smsWithdraw.vue?vue&type=template&id=70455228&scoped=true&"
import script from "./smsWithdraw.vue?vue&type=script&lang=js&"
export * from "./smsWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70455228",
  null
  
)

export default component.exports